import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    maxWidth: toRem(680),
    margin: '0 auto',
    borderBottom: `2px solid ${theme.colors.blueDark}`,
    '&:last-of-type': {
        borderBottom: 'none'
    },
    '.AccordionItem': {
        '& .Button': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'space-between',
            padding: toRems([18, 10, 18, 0]),
            border: 'none',
            [theme.breakpoints.up('md')]: {
                padding: toRems([22, 20])
            },
            '.Title': {
                fontSize: toRem(14),
                color: theme.colors.goldDark,
                maxWidth: '90%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(20)
                }
            },
            '.IconSet': {
                display: 'flex',
                alignItems: 'center',
                '.minus': {
                    width: toRem(14),
                    display: 'none'
                },
                '.plus': {
                    width: toRem(14)
                },
                [theme.breakpoints.up('md')]: {
                    '.minus': {
                        width: toRem(20)
                    },
                    '.plus': {
                        width: toRem(20)
                    }
                }
            },
            '&.active': {
                '.IconSet': {
                    '.minus': {
                        display: 'block'
                    },
                    '.plus': {
                        display: 'none'
                    }
                }
            }
        },
        '.Content': {
            overflow: 'hidden',
            transition: 'max-height 0.6s ease',
            padding: 0,
            position: 'relative',
            top: toRem(-10),
            [theme.breakpoints.up('md')]: {
                padding: toRems([0, 20]),
                top: toRem(-20)
            },
            '.Text': {
                fontSize: toRem(14),
                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(20)
                }
            }
        }
    }
})

export default style
